<!--
 * @Description: 个税列表页面
 * @Author: sunhuihong
 * @Date: 2025-11-6 15:43:52
-->
<template>
  <div class="income-tax-list" v-loading="loading" element-loading-text="正在导出...">
    <el-row class="search-row-margin" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="6" style="text-align: left;">
        <span class="search-title-wrap">机构名称：</span>
        <el-select v-model="filterParams.instId" style="width: 180px;" filterable clearable 
          remote placeholder="请输入并选择机构" size="small" :remote-method="loadInstList" 
          :loading="loadingInstList">
          <el-option v-for="inst in instList" :key="inst.id" size="small" :label="inst.name" 
            :value="inst.id"/>
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: left;">
				<span class="search-title-wrap">人员信息：</span>
				<el-input v-model="filterParams.atdnInfo" size="small" clearable style="width: 180px;"
					placeholder="姓名/手机号/身份证号"></el-input>
			</el-col>
      <el-col :span="6" style="text-align: left;">
				<span class="search-title-wrap">日期：</span>
        <el-date-picker v-model="dateRange" type="monthrange" range-separator="至" start-placeholder="开始月份"
          end-placeholder="结束月份" style="width: 192px" :picker-options="getMonthPickerOptions()" 
          @change="datePickerChange" size="small" prefix-icon="el-icon-date">
        </el-date-picker>			
      </el-col>
      <el-col :span="6" style="text-align: right">
          <el-button size="small" @click="handleSearch" type="primary" icon="el-icon-search" class="btn-search-w80">
			  		搜 索
			  	</el-button>
          <el-button size="small" plain type="primary" class="btn-search-w80"
            style="background: #FEFFFF; color: #3E7EF5;"
            @click="handleExportIncomeTax">
            <el-image :src="require('@/assets/common/icon-common-export.png')" fit="cover" 
              class="export-image">
            </el-image>
            导 出
          </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table class="table-common-style" :style="tableWidth" ref="table" :data="dataTable" 
      :header-cell-style="{'background-color': '#EFF5FA'}">
      <el-table-column label="所属机构" min-width="13%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.instName && scope.row.instName.length < 14" class="overflow-text-style">
            {{scope.row.instName || '- -'}}
          </span>
          <el-popover v-else placement="bottom" title="" width="150" trigger="hover">
            <span>{{scope.row.instName}}</span>
            <span slot="reference" class="overflow-text-style" style="cursor: pointer;">
              {{scope.row.instName}}
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="10%" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <div class="sub-text-style">{{scope.row.desensMobile}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="desensIdCardNo" label="身份证号" min-width="17%" align="left"></el-table-column>
      <el-table-column prop="monthStr" label="日期" min-width="10%" align="left">
        <template slot-scope="scope">
          {{dateFormat(scope.row.month)}}
        </template>
      </el-table-column>
      <el-table-column prop="totalWithdrawalAmountYuan" label="提现总额(元)" min-width="10%" align="left"></el-table-column>
      <el-table-column prop="totalTaxPayableYuan" label="应交税(元)" min-width="10%" align="left"></el-table-column>
      <el-table-column prop="totalActualTaxYuan" label="实交税(元)" min-width="10%" align="left"></el-table-column>
      <el-table-column prop="noTaxReason" label="备注" min-width="12%" align="left"></el-table-column>
      <el-table-column label="操作" min-width="8%" align="left">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetails(scope.row)">
              详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>

    <!-- 个税详情弹框 -->
    <income-tax-details-dialog :visible="showIncomeTaxDetailsDialog" :incomeTaxParams="incomeTaxParams"
      @close-dialog="showIncomeTaxDetailsDialog = false"/>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import Util from "@/global/Util.js";
import IncomeTaxDetailsDialog from './components/incometaxlist/IncomeTaxItemList.vue';

export default {
  name: 'IncomeTaxList',

  components: { 
    'income-tax-details-dialog': IncomeTaxDetailsDialog
  },

  data() {
    return {
      dataTable: [],
      instList: [],
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
			dateRange: this.getDefaultMonthRange(),
      loadingInstList: false,
      loading: false,

      //以下是个税详情弹框组件变量
      incomeTaxParams: {},
      showIncomeTaxDetailsDialog: false,
    }
  },
  
  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },

  methods: {
    initView() {
      this.$set(this.filterParams, 'startDate', this.dateUtil.dateFormat(this.dateRange[0], 'YYYY-MM-DD'));
      this.$set(this.filterParams, 'endDate', this.dateUtil.dateFormat(this.dateRange[1], 'YYYY-MM-DD'));
      this.getIncomeTaxList();
    },

    getIncomeTaxList() {
      return new Promise((resolve) => {
        // 签名
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
            method: 'GET',
            url: Constant.URL_GET_PAGE_MONTHLY_INCOME_TAXES,
            param: this.filterParams,
            header: header,
            contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data || [];
            this.totalNumber = result.totalNumber;
            resolve();
          }
        });
      })
    },

    async loadInstList(filterStr) {
      this.loadingInstList = true;
      let filterParams = {filterStr: filterStr};
      this.instList = await Util.listTop30Institutions(filterParams, Constant.URL_GET_LIST_TOP_30INSTITUTIONS, this);
      this.loadingInstList = false;
    },

    getDefaultMonthRange() {
      let now = new Date();
      let currentYear = now.getFullYear();
      let currentMonth = now.getMonth();
      let lastMonthYear = currentYear;
      let lastMonth = currentMonth - 1;
      if (lastMonth < 0) {
        lastMonthYear = currentYear - 1;
        lastMonth = 11; // 12月
      }
      let lastMonthDate = new Date(lastMonthYear, lastMonth, 1);
      return [lastMonthDate, lastMonthDate];
    },

    // 修改日期选择器的禁用逻辑
    getMonthPickerOptions() {
      return {
        disabledDate: (time) => {
          let current = new Date();
          let currentYear = current.getFullYear();
          let currentMonth = current.getMonth();
          let timeYear = time.getFullYear();
          let timeMonth = time.getMonth();
          // 禁用当前月份及之后的月份
          return timeYear > currentYear || 
            (timeYear === currentYear && timeMonth > currentMonth);
        },
      };
    },

    datePickerChange() {
      this.filterParams.startDate = this.dateRange && this.dateRange.length 
        ? this.dateUtil.dateFormat(this.dateRange[0], 'YYYY-MM-DD') : '';
      this.filterParams.endDate = this.dateRange && this.dateRange.length 
        ? this.dateUtil.dateFormat(this.dateRange[1], 'YYYY-MM-DD') : '';
    },

    dateFormat(date) {
      return this.dateUtil.dateFormat(date, "YYYY-MM");
    },

    //搜索
    handleSearch() {
      this.filterParams.page = 1;
      this.getIncomeTaxList();
    },

    //导出
    async handleExportIncomeTax() {
      if (!this.filterParams.instId) {
        this.$message.error('请选择导出机构');
        return;
      }
      if (!this.filterParams.startDate || !this.filterParams.endDate || (this.filterParams.endDate != this.filterParams.startDate)) {
        this.$message.error('请选择具体一个月');
        return;
      }
      let param = {...this.filterParams}
      delete param.page
      delete param.pageSize
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      this.loading = true;
      await Util.exportExcel(Constant.URL_GET_EXPORT_MONTHLY_INCOME_TAXES, param, header)
      this.loading = false;
    },

    //详情
    handleDetails(row) {
      this.$set(this.incomeTaxParams, 'atdnId', row.attendant.id);
      this.$set(this.incomeTaxParams, 'month', row.month);
      this.showIncomeTaxDetailsDialog = true;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.getIncomeTaxList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.getIncomeTaxList();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '财务管理',text2: '个税列表'});
    this.initView();
  }
}
</script>

<style scoped>
.export-image {
  width: 12px;
  height: 12px;
  vertical-align: bottom;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
  margin-bottom: 33px;
}

.sub-text-style {
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/IncomeTaxList.vue